// src/SchoolRoutes.js
import React from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";

// 🔹 Pages for staff/admins
import AdminDashboard from "./pages/AdminDashboard";
import TicketSummary from "./pages/TicketSummaryPage"; 
import StoreAdmin from "./pages/StoreAdmin";
import StoreMode from "./pages/StoreMode";
import PrintStoreQR from "./pages/PrintStoreQR";
import RedemptionCards from "./components/RedemptionCards";
import AdminTools from "./pages/AdminTools";

// 🔹 Pages for students
import StudentDashboard from "./pages/StudentDashboard";
import StudentStore from "./pages/StudentStore";
import StudentSuggestions from "./pages/StudentSuggestions"; // ✅ NEW

// Simple role guard
function RequireRole({ allow = [], role, children }) {
  if (!allow.includes(role)) {
    return <Navigate to=".." replace />;
  }
  return children;
}

export default function SchoolRoutes({ user, role, advisory }) {
  const { schoolId } = useParams();

  // If not logged in, kick to global login
  if (!user) return <Navigate to="/login" replace />;

  return (
    <Routes>
      {/* Default landing under /:schoolId */}
      <Route
        index
        element={
          role === "admin" || role === "staff" ? (
            <AdminDashboard />
          ) : (
            <StudentDashboard advisory={advisory} />
          )
        }
      />

      {/* Staff/Admin-only routes */}
      <Route
        path="admin"
        element={
          <RequireRole allow={["admin", "staff"]} role={role}>
            <AdminDashboard />
          </RequireRole>
        }
      />
      <Route
        path="summary"
        element={
          <RequireRole allow={["admin", "staff"]} role={role}>
            <TicketSummary />
          </RequireRole>
        }
      />
      <Route
        path="store-admin"
        element={
          <RequireRole allow={["admin", "staff"]} role={role}>
            <StoreAdmin />
          </RequireRole>
        }
      />
      <Route
        path="upload-store"
        element={<Navigate to="../store-admin" replace />}
      />
      <Route
        path="print-store-qr"
        element={
          <RequireRole allow={["admin", "staff"]} role={role}>
            <PrintStoreQR />
          </RequireRole>
        }
      />
      <Route
        path="store-mode"
        element={
          <RequireRole allow={["admin", "staff"]} role={role}>
            <StoreMode />
          </RequireRole>
        }
      />
      <Route
        path="redemption-cards"
        element={
          <RequireRole allow={["admin", "staff"]} role={role}>
            <RedemptionCards />
          </RequireRole>
        }
      />
      <Route
        path="admin-tools"
        element={
          <RequireRole allow={["admin"]} role={role}>
            <AdminTools />
          </RequireRole>
        }
      />

      {/* Student-only routes */}
      <Route
        path="student"
        element={
          <RequireRole allow={["student"]} role={role}>
            <StudentDashboard advisory={advisory} />
          </RequireRole>
        }
      />
      <Route path="store" element={<StudentStore />} />
      <Route
        path="suggestions"
        element={
          <RequireRole allow={["student"]} role={role}>
            <StudentSuggestions />
          </RequireRole>
        }
      />

      {/* Fallback: redirect anything unknown under /:schoolId to home */}
      <Route path="*" element={<Navigate to={`/${schoolId}`} replace />} />
    </Routes>
  );
}
